import React from 'react'
import Style from '../manageEntities.module.css'

/**
 * One direction switch. Controlled, so the checkbox always shows what the hook
 * believes is saved - including after a failed save rolls the value back.
 * `.switch`/`.slider` are the app wide toggle styles from myproducts.css.
 */
const EntityToggle = ({ label, isActive, isEditable, isSaving, onChange }) => (
    <div className={Style.toggleCell}>
        <label
            className={`switch ${Style.switchWrap}`}
            title={isEditable ? label : `${label} cannot be changed for this entity`}
        >
            <input
                type="checkbox"
                checked={isActive}
                disabled={!isEditable || isSaving}
                aria-label={label}
                onChange={(event) => onChange(event.target.checked)}
            />
            <span className="slider round" />
        </label>
        {isSaving ? <span className={Style.cellSpinner} aria-hidden="true" /> : null}
        {!isEditable ? (
            <i className={`uil-lock-alt ${Style.lockIcon}`} aria-hidden="true" />
        ) : null}
    </div>
)

export default EntityToggle
